import { EmblaOptionsType } from "embla-carousel";
import { useEffect, useState } from "react";
import MediaCarousel from "../../components/MediathequeSwiper/MediaCarousel";
import img from "../../images/media.png";
import "../../style/carouselPerView.css";
import { getAllVideos } from "../../API/Mediatheque/Videos/videosService";
const MediathequeVideo = () => {
  const LINKS = [
    {
      id: "1",
      ulr: "https://www.youtube.com/embed/yp9F5W9jVHA",
    },
    { id: "2", url: "https://www.youtube.com/embed/yp9F5W9jVHA" },
    { id: "3", url: "https://www.youtube.com/embed/yp9F5W9jVHA" },
    { id: "4", url: "https://www.youtube.com/embed/yp9F5W9jVHA" },
    { id: "5", url: "https://www.youtube.com/embed/yp9F5W9jVHA" },
    { id: "6", url: "https://www.youtube.com/embed/yp9F5W9jVHA" },
  ];

  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const OPTIONS: EmblaOptionsType = {};

  const SLIDE_COUNT = 4;
  const SLIDE = [
    {
      id: 1,
      url: "https://www.youtube.com/watch?v=DBMjIzxFFMM",
      img: "https://i.ytimg.com/vi/eaX4CpyoE7k/hqdefault.jpg?sqp=-oaymwE2CNACELwBSFXyq4qpAygIARUAAIhCGAFwAcABBvABAfgB1AaAAuADigIMCAAQARhlIFwoWjAP&rs=AOn4CLCInWJ7I0whBEglbMOjEjbnFlwT8A",
    },
    {
      id: 2,
      url: "https://www.youtube.com/watch?v=eaX4CpyoE7k",
      img: "https://i.ytimg.com/vi/pWCVT5YX72w/hqdefault.jpg?sqp=-oaymwE2CNACELwBSFXyq4qpAygIARUAAIhCGAFwAcABBvABAfgB_gmAAtAFigIMCAAQARhkIGQoZDAP&rs=AOn4CLB5-FEK8u9wUeI8g6XmPbnw1-K6_A",
    },
    {
      id: 3,
      url: "https://www.youtube.com/watch?v=pWCVT5YX72w",
      img: "https://i.ytimg.com/vi/N6a7wJ3POnE/hqdefault.jpg?sqp=-oaymwE2CNACELwBSFXyq4qpAygIARUAAIhCGAFwAcABBvABAfgB_gmAAtAFigIMCAAQARhlIFMoTjAP&rs=AOn4CLDBJNIOHe98WXvr6CeiesziKe0Oag",
    },
    {
      id: 4,
      url: "https://www.youtube.com/watch?v=N6a7wJ3POnE",
      img: "https://i.ytimg.com/vi/DBMjIzxFFMM/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBHZzHqBvNOwLZj-qKskr-ehUF4Rg",
    },
  ];

  const [videos, setVideos] = useState<any[]>([]);
  const fetchData = async () => {
    const response = await getAllVideos();
    setVideos(response?.videos);
  };
  useEffect(() => {
    fetchData();
  }, []);
  const SLIDES_TO_DISPLAY = videos.slice(0, 4);
  return (
    <div className=" mb-52">
      <div className="">
        <section
          className="p-10 text-center lg:p-32 bg-black/70 bg-blend-overlay "
          style={{
            backgroundImage: `url(${img})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        >
          <h1 className="text-2xl font-bold text-center text-white md:text-4xl lg:text-7xl">
            {"Médiathèque  "}
          </h1>

          <div className="flex justify-center mt-3">
            <p className="w-full text-white ">
              {"Toutes nos documentations à votre disposition"}
            </p>
          </div>
        </section>
      </div>

      <div className="pb-10 bg-bg_aquavesc">
        <h1 className="p-5 mt-20 text-4xl font-bold text-center text-black uppercase">
          VIDEOS
        </h1>

        <div className="">
          <MediaCarousel slides={SLIDES_TO_DISPLAY} options={OPTIONS} />
        </div>
      </div>
    </div>
  );
};

export default MediathequeVideo;
